import { createSafeContext } from '@/util';

import type { VBasePopoverContextValue } from './type';

const VBasePopoverContext = createSafeContext<VBasePopoverContextValue>(
  null,
  'VBasePopoverContext',
);

export default VBasePopoverContext;
